// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');
const { catalogue, analyticsId } = require('../analytics/hireCardOpenYoungAnalytics');

class HireCardOpenYoungError extends React.Component {
    buildTexts() {
        const { immHireCardOpenYoung, hireRestrictionFlag } = this.props;
        const hireCardFail = immHireCardOpenYoung.get('errorMsg');
        let titleKey = 'hireCardOpenYoung-hireCardOpenYoung_errorTitleGeneric';
        let subtitle = 'hireCardOpenYoung-hireCardOpenYoung_errorSubtitleGeneric';

        if (hireCardFail === 'CHILD_ACCOUNT_ERROR') {
            titleKey = 'hireCardOpenYoung-hireCardOpenYoung_errorTitleAccount';
            subtitle = 'hireCardOpenYoung-hireCardOpenYoung_errorSubtitleAccount';
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            subtitle = 'hireCard-errorRestrictionSubtitleAccount';
        }

        const textElement = (
            <FormattedText
                value={subtitle}
            />
        );

        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail,hireRestrictionFlag } = this.props;
        const {
            textElement,
            titleKey,
        } = this.buildTexts();

        const goBackButton = 
        hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }:{
            label: (
                <FormattedText
                    value="hireCardOpenYoung-hireCardOpenYoung_errorBackButtonText"
                />
            ),
            url: '/myprofile/cards'
        };

    const cancleButton ={
    label: (
        <FormattedText
            value="hireCard-errorRestrictionCancleButtonText"
        />
    ),
    url: '/myprofile/cards'
    };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
                tealium={catalogue[analyticsId.OPEN_YOUNG_CARD_WIZARD_ERROR]({
                    productName: processDetail,
                    errorMessage: formatText(titleKey),
                })}
                isSecondVersion
            >
                <article className="hire-open-young-error">
                    <p>{textElement}</p>
                </article>
            </WizardError>
        );
    }
}

HireCardOpenYoungError.propTypes = {
    immHireCardOpenYoung: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

HireCardOpenYoungError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = HireCardOpenYoungError;
